import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import fontFaces from './depv/fontFaces';
import Header from './depv/Header';
import Footer from './depv/Footer';
import CssBaseline from '../CssBaseline';
import ScrollTopButton from './ScrollTopButton';

const DepvLayout = ({ children }) => {
  return (
    <React.Fragment>
      <Head>
        <style>{fontFaces}</style>
      </Head>
      <CssBaseline />
      <Header />
      {children}
      <Footer />
      <ScrollTopButton />
    </React.Fragment>
  );
};

DepvLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DepvLayout;
